<router-outlet></router-outlet>
<app-configuration></app-configuration>
